import { NgModule } from '@angular/core';

import { NgxDraggableDomDirective } from './directive/ngx-draggable-dom.directive';

@NgModule({
  declarations: [NgxDraggableDomDirective],
  imports: [],
  exports: [NgxDraggableDomDirective],
})
export class NgxDraggableDomModule {}
